const let_9 = [
    "blanching",
    "crackling",
    "fricassee",
    "grenadine",
    "isinglass",
    "appetizer",
    "butterfly",
    "artichoke",
    "asparagus",
    "vegetable",
    "pineapple",
    "pistachio",
    "drumstick",
    "slaughter",
    "shellfish",
    "margarine",
    "tableware",
    "appliance",
    "etiquette",
    "appetizer",
    "cafeteria",
    "pepperoni",
    "spaghetti",
    "enchilada",
    "refresher",
    "chopstick",
    "reception",
    "toothpick",
    "leisurely",
    "widowhood",
    "automatic",
    "sunflower",
    "buckwheat",
    "exquisite",
    "cranberry",
    "marinated",
    "attentive",
    "warehouse",
    "asparagus",
    "gustatory",
    "margarita",
    "casserole",
    "banquette",
    "persimmon",
    "foodstuff",
    "sparkling",
    "delicious",
    "bartender",
    "champagne",
    "authentic",
    "appetizer",
    "inaugural",
    "filleting",
    "elevation",
    "candlelit",
    "perfectly",
    "executive",
    "consuming",
    "celebrity",
    "uncovered",
    "healthful",
    "paramount",
    "institute",
    "flavoring",
    "preheated",
    "chophouse",
    "raspberry",
    "sumptuous",
    "flavorful",
    "minimally",
    "nutrition",
    "shortcake",
    "adventure",
    "alcoholic",
    "courtyard",
    "overnight",
    "succulent",
    "enchilada",
    "stateroom",
    "component",
    "chocolate",
    "artichoke",
    "bountiful",
    "butternut",
    "schnitzel",
    "specialty",
    "breakfast",
    "heartland",
    "seasoning",
    "wholesome",
    "pesticide",
    "firehouse",
    "beefsteak",
    "mincemeat",
    "blueberry",
    "paymaster",
    "roadhouse",
    "molecular",
    "nectarine",
    "whitefish",
    "microwave",
    "sunflower",
    "seasoning",
    "superfine",
    "sassafras",
    "potpourri",
    "raspberry",
    "imitation",
    "sweetener",
    "alligator",
    "detergent",
    "margarine",
    "marmalade",
    "spearmint",
    "coriander",
    "succotash",
    "dandelion",
    "breakfast",
    "butternut",
    "glutinous",
    "southeast",
    "essential",
    "converted",
    "shellfish",
    "delicious",
    "unrefined",
    "beefsteak",
    "drumstick",
    "pepperoni",
    "saltpeter",
    "jellyfish",
    "chocolate",
    "grenadier",
    "crookneck",
    "buttercup",
    "marinated",
    "farmhouse",
    "fantastic",
    "pineapple",
    "carnation",
    "artichoke",
    "protector",
    "applejack",
    "horehound",
    "measuring",
    "miniature",
    "petroleum",
    "enchilada",
    "reduction",
    "honeycomb",
    "condensed",
    "cochineal",
    "zinfandel",
    "starlight",
    "mincemeat",
    "grenadine",
    "champagne",
    "sparkling",
    "valentine",
    "northwest",
    "butterfly",
    "alcoholic",
    "digestive",
    "pirouette",
    "fashioned",
    "container",
    "clubhouse",
    "mouthwash",
    "parchment",
    "fruitcake",
    "southwest",
    "partridge",
    "crocodile",
    "hamburger",
    "corkscrew",
    "muskmelon",
    "jambalaya",
    "potassium",
    "angostura",
    "submarine",
    "decorator",
    "energizer",
    "distilled",
    "swordfish",
    "arrowroot",
    "safflower",
    "whitebait",

];

export default let_9;
